import {Component} from '@angular/core';
import {BaseComponent} from "@base/component/BaseComponent";
import {ServiceBagService} from "@base/component/ServiceBag";
import {ScreenService} from "@core/framework/screen.service";
import {BaseState} from "@base/entities/BaseEntities";
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";

class State extends BaseState {
    SelectOptions: any[] = [];
    SelectGroupedOptions: DataSource;
    SelectedOption: number;
    SelectedDataItems: string[] = [];
    Number: number;
    IsTextAreaOutlined: boolean = false;
    RadioGroupItems: any[] = [];
    ButtonGroupOptions: any[] = [];
}

@Component({
    selector: 'app-demo-editors',
    templateUrl: './demo-editors.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoEditorsComponent extends BaseComponent<State> {

    constructor(A: ServiceBagService, public screen: ScreenService) {
        super(A, 'DemoEditorsComponent', State);
    }

    protected override OnInitComponent() {
        this.State.Number = 47.853;

        this.State.SelectOptions = this.GetSelectOptions();
        this.State.RadioGroupItems = this.GetRadioGroupItems();
        this.State.ButtonGroupOptions = this.GetButtonGroupOptions();
        this.State.SelectGroupedOptions = this.GetSelectGroupOptions();
    }

    public GetSelectedDataItems(): string {
        return this.State.SelectedDataItems.join(', ');
    }

    private GetButtonGroupOptions(): any[] {
        return [
            {
                text: 'Option 1',
                value: 'Value 1'
            },
            {
                text: 'Option 2',
                value: 'Value 2'
            },
            {
                text: 'Option 3',
                value: 'Value 3'
            }
        ];
    }

    private GetRadioGroupItems(): any[] {
        return [
            {
                Text: 'Option 1',
                Value: 'Value 1'
            },
            {
                Text: 'Option 2',
                Value: 'Value 2'
            },
            {
                Text: 'Option 3',
                Value: 'Value 3'
            }
        ]
    }

    private GetSelectOptions(): any[] {
        return [
            {
                Name: "Option 1",
                ExtraField: "Extra Field 1",
                EntryID: 1
            },
            {
                Name: "Option 2",
                ExtraField: "Extra Field 2",
                EntryID: 2
            },
            {
                Name: "Option 3",
                ExtraField: "Extra Field 3",
                EntryID: 3
            }
        ];
    }

    private GetSelectGroupOptions(): DataSource {
        return new DataSource({
            store: new ArrayStore({
                data: [
                    {
                        Name: "Option 1",
                        ExtraField: "Extra Field 1",
                        Group: "Group 1",
                        EntryID: 1
                    },
                    {
                        Name: "Option 2",
                        ExtraField: "Extra Field 2",
                        Group: "Group 1",
                        EntryID: 2
                    },
                    {
                        Name: "Option 3",
                        ExtraField: "Extra Field 3",
                        Group: "Group 2",
                        EntryID: 3
                    },
                    {
                        Name: "Option 4",
                        ExtraField: "Extra Field 4",
                        Group: "Group 2",
                        EntryID: 4
                    }],
                key: "EntryID"
            }),
            group: 'Group'
        });
    }
}
